function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.82 13.55L11.09 1a1.79 1.79 0 00-3.18 0L.18 13.55A1.72 1.72 0 001.77 16h15.46a1.72 1.72 0 001.59-2.45zm-1.16.92a.42.42 0 01-.37.2H1.7a.42.42 0 01-.37-.2.37.37 0 010-.37L9.06 1.56v-.05a.42.42 0 01.39-.24.41.41 0 01.39.24v.05l7.85 12.54a.4.4 0 01-.03.37zM9.5 4.66a.65.65 0 00-.68.61v3.45a.68.68 0 001.36 0V5.27a.65.65 0 00-.68-.61zm.5 6.86a.73.73 0 00-1 0 .78.78 0 00-.15.22.75.75 0 000 .26.74.74 0 000 .25.66.66 0 00.15.22.69.69 0 00.48.19.73.73 0 00.48-.19.66.66 0 00.15-.22.74.74 0 000-.25.75.75 0 000-.26.78.78 0 00-.11-.22z",
  fill: "currentColor"
});

var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16"
  }, props), _ref);
};

export default SvgAlertTriangle;